class MetadataLanguage {
    
    constructor(langs, defaultLang = "en") {
        this.langs = langs;
        this.defaultLang = defaultLang;
    }
    
    // get initial lang of metadata - depends on language of the app
    // and is the app-language accessable in lang-switch
    getInitialLang(lang) {
        if(this.langs.hasOwnProperty(lang)) {
            return this.langs[lang].value;
        }
        
        return this.defaultLang;
    }
    
    switchLang(lang) {
        const keys = Object.keys(this.langs);
        const index = keys.indexOf(lang);
        let nextIndex = index + 1;
                
        // correct if index out of bounds
        if(nextIndex >= keys.length) {
            nextIndex = 0;
        }
        
        return this.langs[keys[nextIndex]].value;
    }
}

export default MetadataLanguage;
